export const UseGetRichTextStyle = (displayOptions: any[]) => {
  if (displayOptions.some((option) => option.fields?.value === 'bold-green')) return 'bold-green';
  return '';
};
